import { useCallback, useContext } from 'react';

import { ADD_APP_PAGE, SETUP_APP_PAGE_BASE_PATH } from 'src/constants';
import { RouteContext } from 'src/context';

interface SetupAppPageUrlParams {
  moduleType: string;
  moduleId: string;
  preset?: string;
  appId?: string;
}

export const useAppSetupPaths = () => {
  const { query } = useContext(RouteContext);
  const { folderId } = query as { folderId?: string };

  const getAppDetailsPagePath = useCallback(
    (slug: string) => {
      const baseUrl = `/app-setup/${slug}`;
      return folderId ? `${baseUrl}?folderId=${folderId}` : baseUrl;
    },
    [folderId],
  );

  const getSetupAppPagePath = useCallback(
    ({ moduleType, moduleId, preset, appId }: SetupAppPageUrlParams) => {
      const params = new URLSearchParams({ moduleType, moduleId });
      if (preset) {
        params.set('preset', preset);
      }
      if (appId) {
        params.set('appId', appId);
      }
      if (folderId) {
        params.set('folderId', folderId);
      }

      return `${SETUP_APP_PAGE_BASE_PATH}?${params.toString()}`;
    },
    [folderId],
  );

  return {
    /** folderId from the URL query param */
    folderId,
    /** path to the add app page */
    addAppPagePath: folderId
      ? `${ADD_APP_PAGE.path}?folderId=${folderId}`
      : ADD_APP_PAGE.path,
    /** builds the path to the app details page for a given slug */
    getAppDetailsPagePath,
    /** builds the full path to the setup app page */
    getSetupAppPagePath,
  } as const;
};
